import env from "./config.json";

const config = env[process.env.REACT_APP_ENV || "development"];
config.common = env.common;

export default config;
